import { useMemo } from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import Conversation from '~components/DiscussionPanel/Conversation'
import { routes } from '~config'
import { useAuth } from '~context/AuthContext'
import { Box, Icon, Text, TinyText } from '~design-system'
import { filterHumanThreads, isSponsorOrReferent } from '~helpers'
import { useThreads } from '~hooks'

const StyledBox = styled(Box)`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.greyLight};
    padding: ${theme.spaces[5]};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-height: 50%;
  `}
`

const StyledList = styled('ul')`
  overflow: scroll;
`

const ChatbotLink = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spaces[2]};
    margin-bottom: ${theme.spaces[2]};
  `}
`

const IconCircle = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ theme }) => css`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${theme.colors.cyanLighter};
  `}
`

const DiscussionPanel = () => {
  const {
    authState: { user },
  } = useAuth()

  const { useGetThreads } = useThreads()
  const { data: threads } = useGetThreads()
  const isMentor = isSponsorOrReferent(user)

  const humanThreads = useMemo(() => filterHumanThreads(threads), [threads])

  return (
    <StyledBox>
      <TinyText textColor="greyDarkest" mb={2} uppercase>
        Discussions
      </TinyText>
      <StyledList>
        <li>
          <ChatbotLink
            as={Link}
            to={`${routes.authenticated.iaAssistant}?tab=mentor`}
            di="f"
            ai="ce"
            jc="sb"
            fd="row"
            pos="relative"
          >
            <Box di="f" ai="ce">
              <IconCircle>
                <Icon name="robot" color="blue" size="bigger" />
              </IconCircle>
              <Text weight="regular" ml={3}>
                {isMentor ? 'Chat IA' : 'Mentor IA'}
              </Text>
            </Box>
          </ChatbotLink>
        </li>

        {humanThreads?.map((thread) => (
          <li key={thread.id}>
            <Conversation thread={thread} />
          </li>
        ))}
        {user?.waitingMatchs.map((wm) => (
          <li key={wm.id}>
            <Conversation
              thread={{
                id: wm.id,
                subject: 'conversation en attente',
                participants: [
                  {
                    id: wm.id,
                    fullName: wm.fullName,
                  },
                ],
                isActive: true,
              }}
              isWaiting
            />
          </li>
        ))}
      </StyledList>
    </StyledBox>
  )
}

export default DiscussionPanel
